import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../../src/api/axiosConfig';
import { useAuth } from "./AuthContext";

const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  const fetchRoles = async () => {
    try {
      const response = await api.get('/admin/roles'); 
      setRoles(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching roles:", error);
      if (error.response?.status !== 401) {
         console.warn("Failed to load roles from database:", error);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!user || !user.id) {
        setRoles([]);
        setLoading(false);
    }
  }, [user]);

  // 2. CREATE ROLE
  const addRole = async (newRole) => {
    try {
      const response = await api.post('/admin/roles', newRole); // Using relative path is safer with api instance
      setRoles([...roles, { ...newRole, id: response.data.insertId || Date.now() }]);
      fetchRoles(); 
      // ✅ SUCCESS TOAST REMOVED (Handled by Component)
      return true;
    } catch (error) {
      console.error("Error adding role:", error);
      toast.error("Failed to create role");
      throw error;
    }
  };

  // 3. UPDATE ROLE
  const updateRole = async (id, updatedData) => {
    try {
      await api.put(`/admin/roles/${id}`, updatedData);
      setRoles(roles.map(role => role.id === id ? { ...role, ...updatedData } : role));
      // ✅ SUCCESS TOAST REMOVED (Handled by Component)
      return true;
    } catch (error) {
      console.error("Error updating role:", error);
      toast.error("Failed to update role");
      throw error;
    }
  };

  // 4. DELETE ROLE
  const deleteRole = async (id) => {
    try {
      await api.delete(`/admin/roles/${id}`);
      setRoles(roles.filter(r => r.id !== id));
      // ✅ SUCCESS TOAST REMOVED (Handled by Component)
      return true;
    } catch (error) {
      console.error("Error deleting role:", error);
      toast.error("Failed to delete role");
      throw error;
    }
  };

  return (
    <RoleContext.Provider value={{ roles, loading, addRole, updateRole, deleteRole, fetchRoles }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRoles = () => useContext(RoleContext);